import { getApiBaseUrl } from "./api";

const STARTUP_HEALTH_KEY = "task-suite:startup-health-v1";
const WARMUP_TIMEOUT_MS = 8000;

// Wake the production API without blocking React rendering. This is especially
// useful when the backend is hosted on a sleeping instance and the first request
// from a new device would otherwise pay the cold-start cost.
export const warmupApi = () => {
  if (typeof window === "undefined" || typeof fetch !== "function") return;
  if (window.sessionStorage.getItem(STARTUP_HEALTH_KEY) === "1") return;

  const baseUrl = getApiBaseUrl();
  if (!baseUrl) return;

  window.sessionStorage.setItem(STARTUP_HEALTH_KEY, "1");
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), WARMUP_TIMEOUT_MS);

  fetch(`${baseUrl}/health`, {
    method: "GET",
    cache: "no-store",
    credentials: "omit",
    signal: controller.signal,
    keepalive: true,
  })
    .then((response) => {
      if (!response.ok) throw new Error(`API health ${response.status}`);
      if (process.env.NODE_ENV !== "production") {
        console.debug("[Startup] API warmup ready");
      }
    })
    .catch((error) => {
      // Warmup is best-effort. Never block or surface this as an application error.
      if (process.env.NODE_ENV !== "production" && error?.name !== "AbortError") {
        console.debug("[Startup] API warmup unavailable", error?.message || error);
      }
    })
    .finally(() => window.clearTimeout(timeout));
};
